// extracted by mini-css-extract-plugin
module.exports = {"row":"Gt2TrustRow_row__z2WKx","item":"Gt2TrustRow_item__WulD8","check":"Gt2TrustRow_check__ThVe2","text":"Gt2TrustRow_text__eQLgT"};